'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge } from '@/comps/primitives/badge';
import { AIFI_DATA_NUMBER_CLASS } from '@/domains/pages/ai-proficiency/typography';
import { MODEL_TIER_COLORS, MODEL_TIER_LABELS } from '@/domains/pages/model-savings/constants';
import type { ModelTier } from '@/domains/pages/model-savings/types';
import { cn } from '@/utils/shad';
type TierBadgeProps = {
  tier: ModelTier;
  /** Trails the tier name inside the badge, e.g. its share of a mix. */
  value?: string;
  /** How the tier reads: a tinted outline, or a neutral outline holding a coloured dot. */
  indicator?: 'border' | 'dot';
  className?: string;
};
export function TierBadge(t0) {
  const $ = _c(17);
  const {
    tier,
    value,
    indicator: t1,
    className
  } = t0;
  const indicator = t1 === undefined ? "border" : t1;
  const color = MODEL_TIER_COLORS[tier];
  const isDot = indicator === "dot";
  const t2 = isDot && "border-border";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("gap-1 border bg-transparent px-1.5 py-0 text-[11px] font-medium", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== color || $[4] !== isDot) {
    t4 = isDot ? undefined : {
      borderColor: color
    };
    $[3] = color;
    $[4] = isDot;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== color || $[7] !== isDot) {
    t5 = isDot ? <span className="size-1.5 shrink-0 rounded-full" style={{
      backgroundColor: color
    }} aria-hidden={true} /> : null;
    $[6] = color;
    $[7] = isDot;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = MODEL_TIER_LABELS[tier];
  let t7;
  if ($[9] !== value) {
    t7 = value ? <span className={AIFI_DATA_NUMBER_CLASS}>{value}</span> : null;
    $[9] = value;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = <Badge variant="outline" pill={true} className={t3} style={t4}>{t5}{t6}{t7}</Badge>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}